<template>
  <div class="drop-down__item">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'drop-down-item',
};
</script>

<style lang="scss">
.drop-down__item {
  padding: 0.5rem 1rem;
  white-space: nowrap;
  display: flex;
  cursor: pointer;

  &:hover {
    background: color('background');
  }

  a {
    flex: 1;
    display: flex;
    align-items: center;

    svg.icon {
      margin-left: 0.5rem !important;
    }
  }
}
</style>
